import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const ToolbarRedoIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M22.15 10.87L13.29 4.3C12.9 3.99 12.28 4.3 12.29 4.8V8.53C8.46001 8.6 5.70001 9.52 3.89001 11.33C2.19001 13.02 1.37001 15.46 1.37001 18.81C1.35001 19.45 2.28001 19.67 2.55001 19.09C4.42001 15.34 8.01001 15.16 12.29 15.16V18.82C12.27 19.32 12.9 19.63 13.29 19.32L22.15 12.75C22.77 12.32 22.77 11.31 22.15 10.88V10.87Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ToolbarRedoIcon.displayName = 'ToolbarRedoIcon';
